/*
 * @Author: Gaho
 * @Date: 2024-01-17 16:43:06
 * @LastEditors: Gaho
 * @LastEditTime: 2024-01-17 16:44:47
 */
import { defineStore } from 'pinia';
export const useLimboStore = defineStore('limbo', {
    state: () => ({
        canBet: true
    }),
})